// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };

import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { Auth } from '../services/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(Auth);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // If logout is in progress, redirect to signin immediately
    if (this.authService.getIsLoggingOut()) {
      return this.router.createUrlTree(['/signin']);
    }

    return this.authService.isAuthenticated().pipe(
      map((isAuthenticated) => {
        // If user is authenticated, allow access to protected pages
        if (isAuthenticated) {
          return true;
        }

        // If user is not authenticated, redirect to signin with redirect to the current url
        return this.router.createUrlTree(['/signin'], {
          queryParams: { redirect: state.url },
        });
      }),
      catchError((error) => {
        console.error('Auth guard error:', error);
        // On error, redirect to signin
        return of(
          this.router.createUrlTree(['/signin'], {
            queryParams: { redirect: state.url },
          }),
        );
      }),
    );
  }
}
